import { authInstance } from './auth-instance';
import { ResponsibleContragentRequest } from '@/types';

export const responsibleContragent = {
    update: (data: ResponsibleContragentRequest) =>
        authInstance.put('ResponsibleContragent', data).then(x => x.data),
};
